import { connect } from 'react-redux';

import { siteboardAction } from '../actions/defaultActions';
import { SET_TERMS_OF_USE_DIALOGUE_OPEN } from '../actions/types';
import PopupWindow from './PopupWindow';

const TermsOfUseDialogue = ({ siteboardAction }) => {
  const sectionHeaderStyle = 'font-bold mt-6';
  const listItemStyle = '';
  const closeDialogue = () => {
    siteboardAction(SET_TERMS_OF_USE_DIALOGUE_OPEN, { isOpen: false });
  };

  return (
    <PopupWindow title={`Terms of Use`} closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='text-[1.2em] text-white max-w-screen-lg'>
        <div>Effective Date: January 21, 2025</div>

        <div className={sectionHeaderStyle}>Introduction  </div>
        Welcome to {process.env.REACT_APP_WEBSITE_NAME}! By accessing or using our website and services, you agree to comply with and be bound by the following Terms and Conditions ("Terms"). If you do not agree with these Terms, please refrain from using our services.  

        <div className={sectionHeaderStyle}>1. Use of the Website and Services  </div>
        <div className={sectionHeaderStyle}>1.1 Eligibility</div>
        You must be at least 18 years old to use our website and services. By using {process.env.REACT_APP_WEBSITE_NAME}, you represent and warrant that you meet this eligibility requirement.  

        <div className={sectionHeaderStyle}>1.2 Acceptable Use  </div>
        You agree to use our website and services only for lawful purposes. Prohibited activities include but are not limited to:  
        <div className={listItemStyle}>- Engaging in fraudulent or illegal activities.  </div>
        <div className={listItemStyle}>- Uploading harmful content such as viruses or malware.  </div>
        <div className={listItemStyle}>- Interfering with the functionality of the website.  </div>

        <div className={sectionHeaderStyle}>2. Account Registration  </div>
        <div className={sectionHeaderStyle}>2.1 Accuracy of Information</div>
        When creating an account, you agree to provide accurate, current, and complete information.  

        <div className={sectionHeaderStyle}>2.2 Account Security </div>
        You are responsible for maintaining the confidentiality of your account credentials. {process.env.REACT_APP_WEBSITE_NAME} is not liable for any unauthorized access to your account.  
        <div className={sectionHeaderStyle}>3. Intellectual Property  </div>
        <div className={sectionHeaderStyle}>3.1 Ownership  </div>
        All content on the {process.env.REACT_APP_WEBSITE_NAME} website, including text, graphics, logos, and software, is the property of {process.env.REACT_APP_WEBSITE_NAME} or its licensors and is protected by intellectual property laws.  

        <div className={sectionHeaderStyle}>3.2 Restrictions  </div>
        You may not reproduce, distribute, or create derivative works of our content without prior written permission.  

        <div className={sectionHeaderStyle}>4. Payment Terms  </div>
        <div className={sectionHeaderStyle}>4.1 Fees and Subscriptions  </div>
        If you purchase any paid features or subscriptions, you agree to pay all applicable fees as outlined during the checkout process.  

        <div className={sectionHeaderStyle}>4.2 Refunds  </div>
        Refund policies, if applicable, will be outlined separately and are subject to our sole discretion.  

        <div className={sectionHeaderStyle}>5. Limitation of Liability  </div>
        {process.env.REACT_APP_WEBSITE_NAME} and its affiliates are not liable for any direct, indirect, incidental, or consequential damages arising from your use of our website or services.  

        <div className={sectionHeaderStyle}>6. Disclaimer of Warranties  </div>
        {process.env.REACT_APP_WEBSITE_NAME} is provided "as is" without warranties of any kind, whether express or implied. We do not guarantee uninterrupted or error-free access to the website or services.  

        <div className={sectionHeaderStyle}>7. Termination  </div>
        We reserve the right to suspend or terminate your access to the website or services at our sole discretion, without prior notice, for any violation of these Terms.  

        <div className={sectionHeaderStyle}>8. Governing Law  </div>
        These Terms are governed by and construed in accordance with all applicable laws of, without regard to its conflict of laws principles.  

        <div className={sectionHeaderStyle}>9. Modifications to Terms  </div>
        We reserve the right to update these Terms at any time. Changes will be effective immediately upon posting. Your continued use of {process.env.REACT_APP_WEBSITE_NAME} constitutes acceptance of the updated Terms.  

        <div className={sectionHeaderStyle}>10. Contact Us  </div>
        If you have any questions or concerns regarding these Terms, please contact us at: 
        <div className='font-bold'>{process.env.REACT_APP_SUPPORT_EMAIL}</div>

        <div className={sectionHeaderStyle}>By using {process.env.REACT_APP_WEBSITE_NAME}, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.  </div>
      </div>
    </PopupWindow>
 );
};

const mapStateToProps = state => { return {}};
export default connect(mapStateToProps, { siteboardAction })(TermsOfUseDialogue);
